import React from 'react';
import { GoogleAuthProvider } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { saveUserSession } from '../../../redux/actions/userActions';
import { useOAuthSignIn } from '../../../utils/Hooks/useOAuthSignIn';
import { AuthButton } from './GoogleAuth.styles';
import GoogleIcon from '../../../assets/images/googleSVG';

const GoogleAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const provider = new GoogleAuthProvider();
  provider.addScope('email');
  provider.addScope('profile');

  const { signIn, isSigningIn } = useOAuthSignIn(provider);

  const handleGoogleSignIn = async () => {
    try {
      const user = await signIn();
      dispatch(saveUserSession(user, 'google'));
      navigate('/onboarding');
    } catch (error) {
      if (error.code !== 'auth/popup-closed-by-user') {
        console.error('Google Sign-In failed:', error.message);
      }
    }
  };

  return (
    <AuthButton
      onClick={handleGoogleSignIn}
      startIcon={<GoogleIcon />}
      variant="contained"
      disabled={isSigningIn}
    >
      {isSigningIn ? 'Signing in...' : 'Sign In with Google'}
    </AuthButton>
  );
};

export default GoogleAuth;